import { render, staticRenderFns } from "./privacy2.vue?vue&type=template&id=1ce316d2&scoped=true&"
import script from "./privacy2.vue?vue&type=script&lang=js&"
export * from "./privacy2.vue?vue&type=script&lang=js&"
import style0 from "./privacy2.vue?vue&type=style&index=0&id=1ce316d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce316d2",
  null
  
)

export default component.exports